module.exports = __webpack_public_path__ + "img/charging-plug-off-line.png";